import { render, staticRenderFns } from "./user-center-offer.vue?vue&type=template&id=ab1f018c&scoped=true"
import script from "./user-center-offer.vue?vue&type=script&lang=js"
export * from "./user-center-offer.vue?vue&type=script&lang=js"
import style0 from "./user-center-offer.vue?vue&type=style&index=0&id=ab1f018c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1f018c",
  null
  
)

export default component.exports